import OpportunitiesAPI from '../api/opportunities';

export const fetchOpenOpportunityForConversation = async conversationId => {
  if (!conversationId) {
    return null;
  }

  try {
    const response = await OpportunitiesAPI.list({
      conversation_id: conversationId,
      status: 'open',
    });
    return response.data?.[0] || null;
  } catch (error) {
    return null;
  }
};
